import React, { useEffect,useCallback, useRef,useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import Select from 'react-select';
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import BulkUploadModal from './BulkUploadModal.js';


function Masters() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    var localStorageEmail = localStorage.getItem("email")

    var [rowData, setRowData] = useState([])
    var [columnDefs1, setColumnDefs1] = useState([
        {
            headerName: "Action",
            field: "_id",
            resizable: true,
            width: 90,
            filter: false,
            cellRenderer: EditItem,
            pinned: "left",
                headerClass: 'bold-header'
            // editable: false
        },
        {
            headerName: "",
            field: "_id",
            width: 50,
            cellRenderer: DeletePartner,
            pinned: "left",
                headerClass: 'bold-header'
        },
        
    ])
    const userMasterColumns =[
        {
            headerName: "User Name",
            field: "username",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
    
        },
        {
            headerName: "Email Id",
            field: "user_id",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Access Type",
            field: "access_type",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Entity",
            field: "entity",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Source",
            field: "source",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Zone",
            field: "zone",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "State",
            field: "state",
            width: 240,
            filter: true,
                headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            width: 240,
            filter: true,
            // valueGetter:function(params){
            //     let tpt = params.data.transporter_name;
            //     if(tpt!== null && tpt !== undefined && tpt !== "undefined"){
            //         return tpt
            //     }
            //     return "All"
            // },
                headerClass: 'bold-header'
        },
    ]

    var [columnDefs, setColumnDefs] = useState([...columnDefs1, ...userMasterColumns])

    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };
    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [rowid ,setRowId] = useState();
    var [originalAccessType ,setOrginalAccessType] = useState();
    var [originalEmailId ,setOriginalEmailId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [username,setUserName] = useState("");
    var [user_id,setUserId] = useState("");
    var [access_type,setAccessType] = useState({label:"", value:""});
    const [accessTypeOptions, setAccessTypeOptions] = useState([
        {'label':'Admin','value':'Admin'},
        {'label':'User','value':'User'},
        {'label':'Transporter','value':'Transporter'},
        {'label':'Warehouse','value':'Warehouse'},
    ]);
    const [entityOptions, setEntityTypeOptions] = useState([
        {'label': 'All', 'value': 'All'},
        {'label': 'Adlec', 'value': 'Adlec'},
        {'label': 'Indoasian', 'value': 'Indoasian'},
        {'label': 'Legrand', 'value': 'Legrand'},
        {'label': 'Numeric', 'value': 'Numeric'},
        {'label': 'Valrack', 'value': 'Valrack'},
        {'label': 'Netrack', 'value': 'Netrack'},
    ])
    var [entity,setEntity] = useState([]);
    var [source,setSource] = useState([]);
    var [zone,setZone] = useState([]);
    var [state,setState] = useState([]);

    var [tpt,setTpt] = useState({label:"", value:""});
    var [warehouse,setWarehouse] = useState({label:"", value:""});
    var [user,setUser] = useState({label:"", value:""});
    const [sourceOptions, setSourceOptions] = useState([])
    const [tptOptions, setTptOptions] = useState([])
    const [warehouseOptions, setWarehouseOptions] = useState([
        {label:"Warehouse Admin", value:"warehouse"},
        {label:"WH-inbound", value:"wh-inbound"},
        {label:"WH-outbound", value:"wh-outbound"},
    ])
    const [userOptions, setUserOptions] = useState([
        {label:"User Admin", value:"user"},
        {label:"User-inbound", value:"user-inbound"},
        {label:"User-outbound", value:"user-outbound"},
    ])
    const [zoneOptions, setZoneOptions] = useState([])
    const [stateOptions, setStateOptions] = useState([])
    const [zoneNStates, setZoneNStates] = useState("")


    var [is_active, setstatus] = useState("");
    // var modules = useState(AllModules);
    var paginationPageSize = useState(50);

    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable:true,
            sortable: true,
            filter: true,
            editable:false

        };
    }, []);
    const filteredOptions = (() => {
        const selectedValue = access_type?.value?.toLowerCase(); // Convert to lowercase for case-insensitive check
        
    
        if (["admin", "admin access"].includes(selectedValue)) 
            return accessTypeOptions.filter(opt => ["User", "Warehouse"].includes(opt.value));
    
        if (["warehouse", "warehouse access", "warehouse admin"].includes(selectedValue)) 
            return accessTypeOptions.filter(opt => ["User", "Admin"].includes(opt.value));
        if (["wh-inbound", "wh-outbound", "user-inbound", "user-outbound"].includes(selectedValue)) 
            return accessTypeOptions.filter(opt => ["User", "Admin", "Warehouse"].includes(opt.value));
    
        if (["user", "user access", "user admin"].includes(selectedValue)) 
            return accessTypeOptions.filter(opt => ["Admin", "Warehouse"].includes(opt.value));
    
        return accessTypeOptions; // Default case when nothing is selected
    })();
    

    var onGridReady = (params) => {
        // gridApi = params.api;
		// gridColumnApi = params.columnApi;
        console.log('params',params)
        console.log('Grid Ready. Column API:', params.columnApi);
        // gridApiRef.current = params.api; 
        // gridColumnApiRef.current = params.columnApi;
    }

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };

    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        loadData();

        // 
    }, [])
    useEffect(() => {
        if (warehouse?.value) {
            applyWarehouseLogic(warehouse.value);
          }
          if(user?.value){
            applyUserLogic(user.value);
          }


      }, [warehouse, user]);

    var loadData = async () => {
        var parameters = {}
        await redirectURL.post('/getUserDetails', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    // const distinctAccessTypes = [...new Set(response.data.map(item => item.source))];
                    // console.log(distinctAccessTypes,"distinctAccessTypes");
                    
                    setRowData(response.data.records);
                    
                }
                // setshowloaderbg("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
            await redirectURL.post('/getSources', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    // const distinctAccessTypes = [...new Set(response.data.map(item => item.source))];
                    // console.log(distinctAccessTypes,"distinctAccessTypes");
                    
                    const seen = new Set();
                    
                    response.data.records.forEach(item => {
                        let lowerCaseSource = item.invoice_source;
                        if (item.invoice_source !== "Nan") {
                            seen.add(lowerCaseSource);
                        }
                    })  
                    const distinctSource = [...seen];
                    const updatedSource = [{ label: 'All Sites', value: 'All Sites' }, ...distinctSource.map(e => { return { label: e, value: e } })];
                 
                    setSourceOptions(updatedSource);
                    
                }
                // setshowloaderbg("show-n");
                setshowloader("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
            await redirectURL.post('/consignments/getTransportersList')
            .then(response => {
                if (response.data.status == "success") {
                    var tptRecords = response.data.tptMaster;

                    var tptNames= tptRecords.map((e)=> e.transporter_name)

                    var tptNamesList=[]
                    const allOptions = [{ label: "All", value: "all" }]; // Define the "All" option

                    // Prepend the "All" option
                    tptNamesList = [...allOptions]; 
                    for (let i of tptNames){
                        tptNamesList.push({label:i, value: i})
                    }
                    setTptOptions(tptNamesList)
                }
                // setshowloaderbg("show-n");
                setshowloader("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
            await redirectURL.post('/getZonesDetails', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    // const distinctAccessTypes = [...new Set(response.data.map(item => item.source))];
                    // console.log(distinctAccessTypes,"distinctAccessTypes");
                    
                    let data = response.data.zones[0].master_data;
                    let zonesList = data.map(e=>({
                        label:e, value:e
                    }))
                    zonesList.unshift({'label': 'All', 'value': 'All'})
                    setZoneOptions(zonesList)
                    
                    
                }
                // setshowloaderbg("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
            await redirectURL.post('/getStateDetails', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    // const distinctAccessTypes = [...new Set(response.data.map(item => item.source))];
                    // console.log(distinctAccessTypes,"distinctAccessTypes");
                    
                    let data = response.data.states[0].master_data;
                    let zoneNStates = data
                    let statesList1=Object.values(zoneNStates).flat()
                    let list= statesList1.map(e=> ({label:e, value:e}))
                    list.unshift({label:"All", value:"All"})

                    setStateOptions(list)
                    setZoneNStates(zoneNStates)
                }
                // setshowloaderbg("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
    }

    var onClickDeleteItem = async (rownode) => {
        // console.log("Rownode Update", rownode);
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async () => {
        var params = {
            user_id: deleteRowData.data.user_id,
            email: decode(localStorageEmail)
        }
    
        try {
            const resp = await redirectURL.post('/deleteUserDetails', params);
            
            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")
                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("User Deleted Successfully");
                setBasicType("success");
                loadData();
            }
        } catch (error) {
            console.error("Error deleting user details:", error);
        }
    };

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add User");
        setUserName("");
        setUserId("");
        setAccessType({label:"", value:""});
        setEntity([]);
        setSource([]);
        setIsEditMode(false);

    }

    var onClickEditBlock  = async (rownode) =>{
        setshowAddSlider("slider-translate-30p");
        let editAccessType = rownode.data.access_type;
        if(["WH-inbound", "WH-outbound"].includes(editAccessType)){
            setAccessType({label:"Warehouse",value:"Warehouse"});
            setWarehouse({label:editAccessType, value:editAccessType.toLowerCase()})
        }else if(["User-inbound", "User-outbound"].includes(editAccessType)){
            setAccessType({label:"User",value:"User"});
            setUser({label:editAccessType, value:editAccessType.toLowerCase()})
        }else{
            setAccessType({label:editAccessType,value:editAccessType.toLowerCase()});
        }
        
        setoverlay("show-m");
        setSliderText("Edit User");
        setRowId(rownode.data._id);
        setOrginalAccessType(rownode.data.access_type)
        setOriginalEmailId(rownode?.data?.user_id)
        setUserName(rownode?.data?.username);
        setUserId(rownode?.data?.user_id);
        setTpt({label:rownode?.data?.transporter_name,value:rownode?.data?.transporter_name})
        const formattedEntity = rownode?.data?.entity?.map(entity=> ({label:entity, value: entity}))

        setEntity(formattedEntity);
        const formattedSource = rownode?.data?.source?.map(source=> ({label:source, value: source}))
        const formattedState = rownode?.data?.state?.map(state=> ({label:state, value: state}))
        const formattedZone = rownode?.data?.zone?.map(zone=> ({label:zone, value: zone}))

        setEntity(formattedEntity);
        setSource(formattedSource);
        setState(formattedState)
        setZone(formattedZone)
        setIsEditMode(true);
    }

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
        setTpt({label:"", value:""})
        setWarehouse({label:"", value:""})
        setUser({label:"", value:""})
        setZone([])
        setState([])
    }


    var saveMasterForm = async (e) => {
        e.preventDefault();
        let user_email = localStorage.getItem('email');
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        setshowloader("show-m")
        const emailRegex = /^[^\s@]+@[^\s@]+\.(com|io|in)$/; 
        let entityValue;
        let sourceValue;
        let zoneValue;
        let stateValue;
        if(entity && entity.length >0){
            entityValue = entity.map((e)=> e.value)
        } 
        if(source && source.length >0){
            sourceValue = source.map((e)=> e.value)
        }
        if(zone && zone.length >0){
            zoneValue = zone.map((e)=> e.value)
        }   
        if(state && state.length >0){
            stateValue = state.map((e)=> e.value)
        } 
        let accessTypeValue;
        var accessType;
        

         if(access_type.value==="User"){
            accessTypeValue= user.label
            accessType = user.value.toLowerCase();
         }else if(access_type.value==="Warehouse"){
            accessTypeValue= warehouse.label;
            accessType = warehouse.value.toLowerCase();
         }else {
            accessTypeValue= access_type.value
            accessType = ["warehouse admin","Warehouse Admin"].includes(accessTypeValue) ? "warehouse" : accessTypeValue.toLowerCase(); // Warehouse Role Login Issue
         }
         let isValid=true; 
         if(accessType!=="transporter"){
            if(zone.length !==0 && state.length !==0){
                isValid=true
            }else{
                isValid=false
            }
         }    
        if(!emailRegex.test(user_id)){
            setShow(true);
            setBasicTitle("Invalid Email");
            setBasicType("danger"); 
            setshowloader("show-n")
    
            return;  
        }
         
         else if(username !== "" && user_id !=="" && accessType !=="" && entity.length !==0 && source.length !==0 && isValid){
            if(isEditMode) {
                var params = {
                    rowid: rowid,
                    username: username,
                    user_id: user_id,
                    access_type: accessTypeValue,
                    entity: entityValue,
                    source: sourceValue,
                    zone: zoneValue,
                    state: stateValue,
                    modified_date: createdDate,
                    user_type: accessType,
                    role:accessType,
                    original_access_type: originalAccessType,
                    original_email_id:originalEmailId,
                    transporter_name: formatToTitleCase(tpt.value),
                    email: decode(localStorageEmail)
                }
            }
            else {
                var params = {
                    username: username,
                    user_id: user_id,
                    access_type: accessTypeValue,
                    entity: entityValue,
                    source: sourceValue,
                    zone: zoneValue,
                    state: stateValue,
                    created_date: createdDate,
                    user_type: accessType,
                    role:accessType,
                    transporter_name: formatToTitleCase(tpt.value),
                    email: decode(localStorageEmail)


                }
            }
            
            if (isEditMode) {
                await redirectURL.post('/updateUserMaster', params).then((resp) => {
                    console.log(resp, "edit response");
                    if (resp.data.status == "success") {
                        setoverlay("show-n");
                        setshowAddSlider("");
                        setshowloader("show-n");
                        setUserName("");
                        setUserId("");
                        setAccessType({label:"", value:""});
                        setEntity([]);
                        setSource([]);
                        setState([]);
                        setZone([]);
                        setstatus("");
                        setIsEditMode(false);
                        setRowId("");
                        setTpt({label:"", value:""})
                        setWarehouse({label:"", value:""})
                        setUser({label:"", value:""})
                        setShow(true);
                        setBasicTitle(resp.data.message);
                        setBasicType("success");
                        loadData();
                    }
                    else{
                        setshowloader("show-n")

                        setShow(true);
                        setBasicTitle(resp.data.message);
                        setBasicType("danger");
                    }
                });
            } else {
                await redirectURL.post('/addUserMaster', params).then((resp) => {
                    if (resp.data.status == "success") {
                        setoverlay("show-n");
                        setshowAddSlider("");
                        setUserName("");
                        setUserId("");
                        setAccessType({label:"", value:""});
                        setEntity([]);
                        setSource([]);
                        setState([]);
                        setZone([]);
                        setstatus("");
                        setIsEditMode(false);
                        setShow(true);
                        setTpt({label:"", value:""})
                        setWarehouse({label:"", value:""})
                        setUser({label:"", value:""})
                        setBasicTitle(resp.data.message);
                        setBasicType("success");
                        loadData();
                    } else if (resp.data.status === "failure") {
                        setoverlay("show-n");
                        setshowloader("show-n");
                        setIsEditMode(false);
                        setshowAddSlider("");
                        setUserName("");
                        setUserId("");
                        setAccessType({label:"", value:""});
                        setTpt({label:"", value:""})
                        setWarehouse({label:"", value:""})
                        setUser({label:"", value:""})
                        setEntity([]);
                        setSource([]);
                        setState([]);
                        setZone([]);
                        setstatus("");
                        setShow(true);
                        setBasicTitle(resp.data.message);
                        setBasicType("danger");
                    }
                }).catch(err => {
                });
            }
         }else{
            setShow(true);
            setBasicTitle("Please fill the mandatory fields");
            setBasicType("danger"); 
            setshowloader("show-n")
    
            return;
         }
       
    };

    var handleUserName = (e) => {
        // if (isEditMode) return;
    
        var inputValue = e.target.value;
        var validInput = inputValue.replace(/[^a-zA-Z\s]/g, '');
    
        if (validInput.length <= 100) {
            setUserName(validInput);
        } else {
            setUserName("");
        }
    }    

    var handleEmailId = (e) => {
        // if (isEditMode) return;
    
        var inputValue = e.target.value;
    
        // Regular expression to validate email format
        // var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
        // if (emailPattern.test(inputValue)) {
            setUserId(inputValue);
        // } else {
            // setUserId("");
        // }
    };

    var handleAccessType = (selectedOption) => {
        setAccessType(selectedOption)
        setUser({label:"", value:""})
        setWarehouse({label:"", value:""})
    }
     
   

    
    var hideDeleteSubmit = ()=>{
        setDeleteConfirmationSlide("");
        setoverlay("show-n");
    
    }
    const handleSelectZone=(zones)=>{
        if (!zones) {
            setZone([]);
            setState([]);
            setStateOptions([]);
            return;
        }

        const isAllSelected = zones.some(item => item.label === "All");
        if (isAllSelected) {
            zones = [{ label: "All", value: "All" }];
        } else {
            zones = zones.filter(item => item.value !== "All");
        }

        setZone(zones)
        let statesArr=[]

        // const isAllSelected = zones.some(item=>item.label==="All");
        
        if(isAllSelected){
            statesArr= Object.values(zoneNStates).flat()
        }else{
            
            let zoneValues= zones.map(item=> item.value)
            if(zoneValues.length>0){
                for(let i of zoneValues){
                    
                    statesArr.push(...zoneNStates[i])
                }
            }
        }
        setState([])
        let statesList = statesArr.map(e=>({
            label:e, value: e
        }))
        statesList.unshift({label:"All", value:"All"})
        
        setStateOptions(statesList)
        
    }
    const applyWarehouseLogic = (value) => {
        if (value === "wh-inbound") {
          const allSources = sourceOptions.find(opt => opt.label === "All Sites");
          if (allSources) setSource([allSources]);
        } else if (value === "wh-outbound") {
          const allZones = zoneOptions.find(opt => opt.label === "All");
          const allStates = stateOptions.find(opt => opt.label === "All");
          if (allZones && allStates) {
            setZone([allZones]);
            setState([allStates]);
          }
        }
      };
      const applyUserLogic = (value) => {
        if(value ==="user-inbound"){
            const allSources = sourceOptions.find(opt=> opt.label ==="All Sites")
            if(allSources){
                setSource([allSources])
            }
        }else if(value ==="user-outbound"){
            const allZones = zoneOptions.find(opt=> opt.label==="All")
            const allStates = stateOptions.find(opt=> opt.label==="All")
            if(allZones && allStates){
                setZone([allZones])
                setState([allStates])
            }
        }
      };
      const handleWarehouseChange = (e) => {
        setWarehouse(e);
        applyWarehouseLogic(e?.value);
      };
      const handleUserChange = (e) => {
        setUser(e);
        applyUserLogic(e?.value);
      };

    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid">
    {/* Row for Heading and Buttons */}
    <div className="row align-items-center justify-content-between mb-3">
        {/* Heading */}
        <div className="col-auto">
            <h5 className="f18 d-flex align-items-center master-title">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>&nbsp;User Master
            </h5>
        </div>

        {/* Buttons */}
        <div className="col-auto d-flex">
            <BulkUploadModal
                show={showBulkUploadModal}
                onClose={closeBulkUploadModal}
                columnDefs={userMasterColumns}
                screen={"user_master"}
                templateUrl={require('../../assets/json/user_master_template.csv')}
            />

            {Constants.VEHICLES.BTN_ADD === 1 && (
                <button
                    className="btn btn-warning"
                    onClick={showAddBlock}
                    style={{ padding: "8px 15px", height: "35px" }}
                >
                    <i className="icon-plus"></i>&nbsp;Add User
                </button>
            )}
        </div>
    </div>

    {/* Main Content */}
    <div className="row">
        <div className="col-xl-12 col-md-12 xl-60">
            <div className="card">
                <div className="card-body">
                    <div
                        className="ag-theme-balham mt-3"
                        style={{ height: "500px", width: "100%" }}
                    >
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rowData}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            paginationPageSize={50}
                            onGridReady={onGridReadyConsignments}
                            enableRangeSelection={true}
                            enableCellContextMenu={true}
                            masterDetail={true}
                            context={{ onClickEditBlock, onClickDeleteItem }}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        labelKey: "columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel",
                                        toolPanelParams: {
                                            suppressPivotMode: true,
                                            suppressRowGroups: true,
                                            suppressValues: true,
                                        },
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        labelKey: "filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel",
                                    },
                                ],
                            }}
                            statusBar={{
                                statusPanels: [
                                    {
                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                        align: "left",
                                    },
                                    {
                                        statusPanel: "agTotalRowCountComponent",
                                        align: "center",
                                    },
                                    { statusPanel: "agFilteredRowCountComponent" },
                                    { statusPanel: "agSelectedRowCountComponent" },
                                    { statusPanel: "agAggregationComponent" },
                                ],
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

            <div className={"overlay-part " + (overlay)} onClick={hideAll}></div>

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                <h4 className="slide-r-title">{sliderText}
                <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>
                    </h4>
                </div>
               
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>User Name<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="username" value={username} style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                            }} onChange={handleUserName} required 
                            autoComplete='off'
/>
                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Email id<span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="email"
                                name="user_id"
                                id="user_id"
                                value={user_id}
                                onChange={handleEmailId}
                                required
                                // disabled={isEditMode}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                }}
                                autoComplete='off'

                            />
                        </div>
                        {isEditMode && 
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Access Type<span style={{ color: 'red' }}>*</span></label>
                            <Select

                            closeMenuOnSelect={true}
                            value={access_type}
                            
                            onChange={handleAccessType}
                         
                         options={filteredOptions}
                         isDisabled={["transporter", "transporter access"].includes(access_type?.value)}
                         />
                          
                        </div>}
                        {!isEditMode && <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Access Type<span style={{ color: 'red' }}>*</span></label>
                            <Select

                            closeMenuOnSelect={true}
                             value={access_type}
                            
                            onChange={handleAccessType}
                         
                         options={accessTypeOptions}
                         />
                          
                        </div>}
                        

                        {(access_type.value==="Warehouse") && 
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Warehouse<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={true}
                             value={warehouse}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange = {handleWarehouseChange}
                            options={warehouseOptions}
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>}
                        {(access_type.value==="User") && 
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>User<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={true}
                             value={user}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange = {handleUserChange}

                           
                            options={userOptions}
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>}

                        {(access_type.value==="Transporter") && 
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Transporter<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={true}
                             value={tpt}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange={(e)=> setTpt(e)}
                            options={tptOptions}
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>}

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Entity<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={false}
                             value={entity}
                             isMulti={true}
                            // className={"border-radius-0"} 
                            // onChange={(e)=> setEntity(e)}
                            onChange={(e) => {
                                const hasAll = e?.some(opt => opt.value === "All");
                                if (hasAll) {
                                    setEntity([{ label: "All", value: "All" }]);
                                } else {
                                    setEntity(e?.filter(opt => opt.value !== "All") || []);
                                }
                            }}
                            options={entityOptions}
                            isOptionDisabled={(option) =>
                                entity.some((opt) => opt.value === "All") && option.value !== "All"
                            }
                            // style={{ borderRadius: "0px" }}
                            // styles={{
                            //     control: (provided, state) => ({
                            //         ...provided,
                            //         fontSize: "0.8rem",
                            //         color: "#6e707e",
                            //         minHeight: "22px",
                            //         width: "178px"
                            //     }),
                            //     menu: (provided, state) => ({
                            //         ...provided,
                            //         minHeight: "22px",
                            //         width: "178px",
                            //         overflowY:"auto",
                            //         maxHeight:"100px"

                            //     }),

                            // }}
                        />
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Source<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={false}
                            value={source}
                            isMulti={true}
                            // className={"border-radius-0"} 
                            // onChange={(e)=> setSource(e)}
                            onChange={(e) => {
                                const hasAll = e?.some(opt => opt.value === "All Sites");
                                if (hasAll) {
                                    setSource([{ label: "All Sites", value: "All Sites" }]);
                                } else {
                                    setSource(e?.filter(opt => opt.value !== "All Sites") || []);
                                }
                            }}
                            options={sourceOptions}
                            isOptionDisabled={(option) =>
                                source.some(opt => opt.value === "All Sites") && option.value !== "All Sites"
                            }
                            isDisabled={((user?.value==="user-inbound") || (warehouse?.value==="wh-inbound")) && access_type.value !=="Admin"}
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>
                      
                        {access_type.value.toLowerCase() !=="transporter" &&
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Destination Zone<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={false}
                             value={zone}
                            isMulti={true}
                            // className={"border-radius-0"} 
                            onChange={handleSelectZone}
                            options={zoneOptions}
                            isDisabled={(user?.value ==="user-outbound" || (warehouse?.value ==="wh-outbound")) && access_type.value !=="Admin"}
                            isOptionDisabled={(option) =>
                                zone.some(opt => opt.value === "All") && option.value !== "All"
                            }
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>}
                        {access_type.value.toLowerCase() !=="transporter" &&
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Destination State<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={false}
                             value={state}
                            isMulti={true}
                            // className={"border-radius-0"} 
                            // onChange={(e)=> setState(e)}
                            onChange={(e) => {
                                const hasAll = e?.some(opt => opt.value === "All");
                                if (hasAll) {
                                    setState([{ label: "All", value: "All" }]);
                                } else {
                                    setState(e?.filter(opt => opt.value !== "All") || []);
                                }
                            }}
                            options={stateOptions}
                            isDisabled={(user?.value ==="user-outbound" || warehouse?.value ==="wh-outbound") &&  access_type.value !=="Admin"}
                            isOptionDisabled={(option) =>
                                state.some(opt => opt.value === "All") && option.value !== "All"
                            }
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>}

                        {/* <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Source<span style={{ color: 'red' }}>*</span></label>
                            <Select

                            closeMenuOnSelect={true}
                             value={source}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange={handleSource}
                            // style={{ borderRadius: "0px" }}
                            styles={{
                                control: (provided, state) => ({
                                    ...provided,
                                    fontSize: "0.8rem",
                                    color: "#6e707e",
                                    minHeight: "22px",
                                    width: "178px"
                                }),
                                menu: (provided, state) => ({
                                    ...provided,
                                    minHeight: "22px",
                                    width: "178px",
                                    overflowY:"auto",
                                    maxHeight:"100px"

                                }),

                            }}
                         options={sourceOptions}
                        />
                        </div> */}
                        
                        {isEditMode ? 
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Update User</button>
                        </div>
                        </>
                        :
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add User</button>
                        </div>
                        </>
                        }
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div> */}

                    </form>
                </div>

            </div>


            {deleteConfirmationSlide
                 && 
                 <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>
                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                            </div>
                </div>                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                    <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                </div>

                </div>} 
            <div className={"dataLoadpage " +(showloader)}>
                </div>
                <div className={"dataLoadpageimg " +(showloader)}>
                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                </div>
                {/* <div className={"overlay-part "+(overlay)} onClick={hideAll}></div> */}


        </div>
    );
}
function formatToTitleCase(str) {
    return str
        .toLowerCase() // Convert the entire string to lowercase
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
}

export default Masters;
